import * as React from 'react';
export const openaiSvg = React.forwardRef(function openaiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0F0F0F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M14.728 4c-2.661 0-5.025 1.69-5.85 4.186a6.122 6.122 0 0 0-2.343 1.02 6.027 6.027 0 0 0-1.71 1.881 5.982 5.982 0 0 0 .759 7.087 5.886 5.886 0 0 0 .519 4.9c1.326 2.284 3.995 3.455 6.607 2.91a6.06 6.06 0 0 0 2.061 1.494c.787.347 1.64.525 2.503.522 2.66 0 5.025-1.69 5.849-4.186a6.043 6.043 0 0 0 4.045-2.901 5.97 5.97 0 0 0-.75-7.087v-.008a5.903 5.903 0 0 0-.519-4.909c-1.327-2.276-3.996-3.446-6.599-2.902a6.087 6.087 0 0 0-2.067-1.488A6.16 6.16 0 0 0 14.728 4Zm0 1.56-.008.009c1.07 0 2.1.365 2.924 1.04-.033.016-.099.057-.148.081l-4.844 2.756a.776.776 0 0 0-.395.682v6.47l-2.085-1.187v-5.348a4.47 4.47 0 0 1 1.334-3.181 4.594 4.594 0 0 1 3.222-1.321Zm5.835 1.884a4.607 4.607 0 0 1 2.287.602 4.53 4.53 0 0 1 1.673 1.652c.527.91.725 1.974.544 3.007-.033-.025-.1-.057-.14-.082L20.082 9.86a.82.82 0 0 0-.8 0l-5.675 3.235V10.72l4.687-2.674a4.583 4.583 0 0 1 2.268-.603ZM8.583 9.901v5.68c0 .285.148.537.395.683l5.668 3.227-2.093 1.194-4.68-2.665a4.51 4.51 0 0 1-2.12-2.733 4.449 4.449 0 0 1 .457-3.412 4.553 4.553 0 0 1 2.373-1.974Zm10.857 1.405 4.688 2.666a4.46 4.46 0 0 1 1.663 6.145l.008.008a4.532 4.532 0 0 1-2.372 1.967V16.41a.775.775 0 0 0-.396-.682l-5.675-3.235 2.084-1.187Zm-3.443 1.96 2.389 1.365v2.722l-2.39 1.365-2.388-1.365v-2.722l2.389-1.366Zm3.756 2.145 2.084 1.187v5.34c0 2.486-2.043 4.502-4.555 4.502v-.008a4.588 4.588 0 0 1-2.917-1.04c.033-.016.108-.057.149-.082l4.844-2.755a.76.76 0 0 0 .395-.683v-6.46Zm-1.36 3.495v2.373l-4.687 2.666c-2.183 1.235-4.967.503-6.228-1.642h.008a4.41 4.41 0 0 1-.543-3.007c.033.024.099.056.14.08l4.844 2.764a.82.82 0 0 0 .799 0l5.668-3.234Z',
    }),
  );
});
openaiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var openai = {
  category: 'brand',
  colorable: false,
  name: 'openai',
  svg: openaiSvg,
};
